import * as React from "react";

import { IconSvgProps } from "@/types";

export const Logo: React.FC<IconSvgProps> = ({
  size = 36,
  height,
  ...props
}) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 35 36"
    width={size || height}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10918_44636)">
      <mask
        height="37"
        id="mask0_10918_44636"
        maskUnits="userSpaceOnUse"
        // style="mask-type:alpha"
        width="37"
        x="-7"
        y="4"
      >
        <path
          clipRule="evenodd"
          d="M24.5538 24.8025C27.7263 22.9053 29.8505 19.4361 29.8505 15.4708C29.8505 9.47004 24.9859 4.60547 18.9851 4.60547C14.7497 4.60547 11.0803 7.02888 9.28789 10.5647L-6.00098 25.8536L8.7509 40.6055L24.5538 24.8025Z"
          fill="#795E5E"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_10918_44636)">
        <path
          clipRule="evenodd"
          d="M18.8035 3.8191L18.8092 3.8133C17.0964 3.8454 15.442 4.30685 14.0192 5.2093C12.9522 6.34381 11.908 7.50118 10.8975 8.69026C9.79735 9.98195 8.73614 11.3088 7.72664 12.6797C7.35105 13.1946 6.98104 13.717 6.63171 14.2601C7.17479 13.9107 7.69719 13.5407 8.21211 13.1651C8.8196 12.7166 9.41933 12.2583 10.0104 11.7914C12.8991 9.5122 15.6058 7.01666 18.2058 4.42764C18.4054 4.22581 18.604 4.02293 18.8035 3.8191ZM17.5227 10.5995C19.4498 8.65059 21.3591 6.67817 23.2144 4.65745C22.4398 4.34139 21.6446 4.1133 20.8485 3.97551C19.1314 5.57502 17.4471 7.20922 15.7811 8.85785C13.8642 10.7922 11.9662 12.7512 10.1222 14.7584C7.44819 17.6653 4.88251 20.673 2.52364 23.8569C5.39999 21.7251 8.13414 19.4264 10.7774 17.0291C13.0811 14.9431 15.318 12.7846 17.5227 10.5995ZM26.522 6.67062C23.8022 9.6821 20.9818 12.6005 18.1273 15.4811C16.415 17.1804 14.6895 18.8667 12.9389 20.5259C9.1151 24.1515 5.17226 27.6524 0.987615 30.8792C4.28816 26.599 7.87577 22.5716 11.5903 18.6655C13.1703 17.005 14.772 15.3662 16.3857 13.7395C19.1949 10.9564 22.0408 8.20415 24.9722 5.54705C25.508 5.87548 26.0266 6.24947 26.522 6.67062ZM29.0813 9.61913C28.7491 9.0871 28.3703 8.57326 27.9465 8.08278C24.9331 10.8044 22.0118 13.6277 19.1293 16.4841C17.4291 18.1974 15.7409 19.9248 14.0798 21.6773C10.4551 25.5001 6.95717 29.4422 3.73123 33.6238C8.00369 30.3288 12.0255 26.749 15.925 23.0411C17.5921 21.4545 19.2375 19.8461 20.871 18.2257C23.6607 15.4098 26.4186 12.5583 29.0813 9.61913ZM29.9834 11.3658C30.3058 12.1297 30.5414 12.9151 30.6887 13.7018C29.0723 15.44 27.4171 17.1432 25.7495 18.8303C23.7962 20.7663 21.8171 22.6822 19.7887 24.5451C16.9008 27.2001 13.9121 29.7447 10.7504 32.0878C12.8719 29.2239 15.1603 26.5023 17.5471 23.8695C19.6415 21.5531 21.8114 19.3048 24.0079 17.0887C25.9673 15.1511 27.9501 13.2314 29.9834 11.3658ZM29.6971 20.304C30.4812 18.919 30.8717 17.342 30.8771 15.7148C30.6426 15.9427 30.4093 16.1717 30.1779 16.4008C27.5594 19.0302 25.0375 21.7677 22.7374 24.6926C22.2968 25.2529 21.8648 25.8199 21.4405 26.3945C21.0639 26.9104 20.6949 27.4318 20.3455 27.9749C20.8886 27.6256 21.411 27.2555 21.9259 26.88C23.1855 25.9513 24.4097 24.9797 25.6031 23.9735C27.0061 22.7925 28.3674 21.564 29.6971 20.304Z"
          fill="url(#paint0_linear_10918_44636)"
          fillRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_10918_44636"
        x1="25.0643"
        x2="60.9696"
        y1="70.2858"
        y2="27.5034"
      >
        <stop stopColor="#FF2189" />
        <stop offset="1" stopColor="#FF9D00" />
      </linearGradient>
      <clipPath id="clip0_10918_44636">
        <rect
          fill="white"
          height="34.7896"
          transform="translate(0 0.605469)"
          width="34.6455"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MoonFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
);

export const SunFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
);

export const HeartFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SearchIcon = (props: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const NextUILogo: React.FC<IconSvgProps> = (props) => {
  const { width, height = 40 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 161 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="fill-black dark:fill-white"
        d="M55.6827 5V26.6275H53.7794L41.1235 8.51665H40.9563V26.6275H39V5H40.89L53.5911 23.1323H53.7555V5H55.6827ZM67.4831 26.9663C66.1109 27.0019 64.7581 26.6329 63.5903 25.9044C62.4852 25.185 61.6054 24.1633 61.0537 22.9582C60.4354 21.5961 60.1298 20.1106 60.1598 18.6126C60.132 17.1113 60.4375 15.6228 61.0537 14.2563C61.5954 13.0511 62.4525 12.0179 63.5326 11.268C64.6166 10.5379 65.8958 10.16 67.1986 10.1852C68.0611 10.1837 68.9162 10.3468 69.7187 10.666C70.5398 10.9946 71.2829 11.4948 71.8992 12.1337C72.5764 12.8435 73.0985 13.6889 73.4318 14.6152C73.8311 15.7483 74.0226 16.9455 73.9968 18.1479V19.0773H63.2262V17.4194H72.0935C72.1083 16.4456 71.8952 15.4821 71.4714 14.6072C71.083 13.803 70.4874 13.1191 69.7472 12.6272C68.9887 12.1348 68.1022 11.8812 67.2006 11.8987C66.2411 11.8807 65.3005 12.1689 64.5128 12.7223C63.7332 13.2783 63.1083 14.0275 62.6984 14.8978C62.2582 15.8199 62.0314 16.831 62.0352 17.8546V18.8476C62.009 20.0078 62.2354 21.1595 62.6984 22.2217C63.1005 23.1349 63.7564 23.9108 64.5864 24.4554C65.4554 24.9973 66.4621 25.2717 67.4831 25.2448C68.1676 25.2588 68.848 25.1368 69.4859 24.8859C70.0301 24.6666 70.5242 24.3376 70.9382 23.919C71.3183 23.5345 71.6217 23.0799 71.8322 22.5799L73.5995 23.1604C73.3388 23.8697 72.9304 24.5143 72.4019 25.0506C71.8132 25.6529 71.1086 26.1269 70.3314 26.4434C69.4258 26.8068 68.4575 26.9846 67.4831 26.9663V26.9663ZM78.8233 10.4075L82.9655 17.325L87.1076 10.4075H89.2683L84.1008 18.5175L89.2683 26.6275H87.103L82.9608 19.9317L78.8193 26.6275H76.6647L81.7711 18.5169L76.6647 10.4062L78.8233 10.4075ZM99.5142 10.4075V12.0447H91.8413V10.4075H99.5142ZM94.2427 6.52397H96.1148V22.3931C96.086 22.9446 96.2051 23.4938 96.4597 23.9827C96.6652 24.344 96.9805 24.629 97.3589 24.7955C97.7328 24.9548 98.1349 25.0357 98.5407 25.0332C98.7508 25.0359 98.9607 25.02 99.168 24.9857C99.3422 24.954 99.4956 24.9205 99.6283 24.8853L100.026 26.5853C99.8062 26.6672 99.5805 26.7327 99.3511 26.7815C99.0274 26.847 98.6977 26.8771 98.3676 26.8712C97.6854 26.871 97.0119 26.7156 96.3973 26.4166C95.7683 26.1156 95.2317 25.6485 94.8442 25.0647C94.4214 24.4018 94.2097 23.6242 94.2374 22.8363L94.2427 6.52397ZM118.398 5H120.354V19.3204C120.376 20.7052 120.022 22.0697 119.328 23.2649C118.644 24.4235 117.658 25.3698 116.477 26.0001C115.168 26.6879 113.708 27.0311 112.232 26.9978C110.759 27.029 109.302 26.6835 107.996 25.9934C106.815 25.362 105.827 24.4161 105.141 23.2582C104.447 22.0651 104.092 20.7022 104.115 19.319V5H106.08V19.1831C106.061 20.2559 106.324 21.3147 106.843 22.2511C107.349 23.1459 108.094 23.8795 108.992 24.3683C109.993 24.9011 111.111 25.1664 112.242 25.139C113.373 25.1656 114.493 24.9003 115.495 24.3683C116.395 23.8815 117.14 23.1475 117.644 22.2511C118.16 21.3136 118.421 20.2553 118.402 19.1831L118.398 5ZM128 5V26.6275H126.041V5H128Z"
      />
      <path
        className="fill-black dark:fill-white"
        d="M23.5294 0H8.47059C3.79241 0 0 3.79241 0 8.47059V23.5294C0 28.2076 3.79241 32 8.47059 32H23.5294C28.2076 32 32 28.2076 32 23.5294V8.47059C32 3.79241 28.2076 0 23.5294 0Z"
      />
      <path
        className="fill-white dark:fill-black"
        d="M17.5667 9.21729H18.8111V18.2403C18.8255 19.1128 18.6 19.9726 18.159 20.7256C17.7241 21.4555 17.0968 22.0518 16.3458 22.4491C15.5717 22.8683 14.6722 23.0779 13.6473 23.0779C12.627 23.0779 11.7286 22.8672 10.9521 22.4457C10.2007 22.0478 9.5727 21.4518 9.13602 20.7223C8.6948 19.9705 8.4692 19.1118 8.48396 18.2403V9.21729H9.72854V18.1538C9.71656 18.8298 9.88417 19.4968 10.2143 20.0868C10.5362 20.6506 11.0099 21.1129 11.5814 21.421C12.1689 21.7448 12.8576 21.9067 13.6475 21.9067C14.4374 21.9067 15.1272 21.7448 15.7169 21.421C16.2895 21.1142 16.7635 20.6516 17.0844 20.0868C17.4124 19.4961 17.5788 18.8293 17.5667 18.1538V9.21729ZM23.6753 9.21729V22.845H22.4309V9.21729H23.6753Z"
      />
    </svg>
  );
};

export const DownloadIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 35 36"
      width={size || width}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>
          .cls-1
          {`{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}`}
        </style>
      </defs>

      <title />

      <g data-name="74-file" id="_74-file">
        <path className="cls-1" d="M11,1H27V31H5V7Z" />

        <polyline className="cls-1" points="11 1 11 7 5 7" />

        <line className="cls-1" x1="11" x2="23" y1="14" y2="14" />

        <line className="cls-1" x1="9" x2="23" y1="18" y2="18" />

        <line className="cls-1" x1="9" x2="23" y1="22" y2="22" />
      </g>
    </svg>
  );
};

export const FilterIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 35 36"
      width={size || width}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H19.4C19.9601 3 20.2401 3 20.454 3.10899C20.6422 3.20487 20.7951 3.35785 20.891 3.54601C21 3.75992 21 4.03995 21 4.6V6.33726C21 6.58185 21 6.70414 20.9724 6.81923C20.9479 6.92127 20.9075 7.01881 20.8526 7.10828C20.7908 7.2092 20.7043 7.29568 20.5314 7.46863L14.4686 13.5314C14.2957 13.7043 14.2092 13.7908 14.1474 13.8917C14.0925 13.9812 14.0521 14.0787 14.0276 14.1808C14 14.2959 14 14.4182 14 14.6627V17L10 21V14.6627C10 14.4182 10 14.2959 9.97237 14.1808C9.94787 14.0787 9.90747 13.9812 9.85264 13.8917C9.7908 13.7908 9.70432 13.7043 9.53137 13.5314L3.46863 7.46863C3.29568 7.29568 3.2092 7.2092 3.14736 7.10828C3.09253 7.01881 3.05213 6.92127 3.02763 6.81923C3 6.70414 3 6.58185 3 6.33726V4.6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
